<template>
  <div class="col-12 form-group form-group-sm">
    <label class="label" for="grupo">Grupo</label>
    <multiselect-item
      id="grupo"
      v-model="grupo"
      :custom-label="label"
      :options="grupoOptions"
      placeholder="Seleccione un grupo"
      track-by="id_grupo"
      :loading="isLoading"
    ></multiselect-item>
  </div>
</template>

<script>
import { get } from "lodash-es";
import axios from "axios";

export default {
  name: "SelectGrupo",
  props: ["value"],
  beforeMount() {
    this.getGrupos();
  },
  data: () => ({
    grupoOptions: [],
    isLoading: true,
  }),
  methods: {
    label(grupo) {
      return `${grupo.grupo_nombre}`;
    },
    async getGrupos() {
      try {
        this.isLoading = true;
        const resp = await axios.post("/execute", {
          method: "CLI.GetGruposByClienteId",
          parameters: [
            {
              name: "id_cliente",
              value: this.$route.params.id_cliente,
            },
          ],
        });
        if (resp.data.ok) {
          this.grupoOptions = get(resp, "data.result[0]", []);
        } else {
          this.$msgBoxOk(resp.data.message);
        }
        this.isLoading = false;
      } catch (e) {
        this.$msgBoxOk(e.toString());
      }
    },
  },
  computed: {
    grupo: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    grupoOptions(val) {
      this.$emit("cantidadGrupos", val.length);
    },
  },
};
</script>

<style scoped></style>
